// eslint-disable-next-line
export const MUI_LICENSEKEY='a5ad72e93b3cfc3a403ef63f4fb2e941Tz0xMzAzMzYsRT0xODEzMzYzMTk5MDAwLFM9cHJlbWl1bSxMTT1hbm51YWwsUFY9aW5pdGlhbCxLVj0y';

export const GOOGLE_MAPS_KEY = 'AIzaSyAXvH-bI5wQVpOPTFhG1znf3-wEl3VypwE';

export const ORS_API_KEY = '5b3ce3597851110001cf62487737cd96968a4e6698e17e145d20776f';

export const GOOGLE_RECAPTCHA_SITE_KEY = '6LckICcqAAAAAL5FovBNoqu0KYJ5rGSO652uaDSg';

export const DEFAULT_IMG = 'https://premiummarketplaceimages.s3.us-east-2.amazonaws.com/placeholder.png';

export const FIREBASE_PAY_COLLECTION_DB = 'PremiumPayDev';

export const FIREBASE_DRILL_COLLECTION_DB = 'PremiumDrillDev';

export const ACCESS_TYPES = {
  NORMAL: 'normal',
  NEW_USER: 'newUser',
  FORGOTTEN_PASSWORD: 'forgottenPassword',
};

export const ASSET_DATA_TYPES = {
  ACTUATORDATA: 'ActuatorData',
  DRILLINGDATA: 'DrillingData',
};

export const ORDER_STATUS_TYPES = {
  1: 'Approving',
  2: 'Declining',
  3: 'Cancelling'
};

export const ORDER_STATUS_ACTIONS = {
  1: 'Approve',
  2: 'Decline',
  3: 'Cancel'
};

export const ORDER_STATUS_SUMBITTED = {
  1: 'Approved',
  2: 'Declined',
  3: 'Canceled'
};

export const MAP_TYPES = {
  GOOGLEMAP: 'googlemap',
  LEAFLETMAP: 'leafletmap'
};

export const REDUX_ACTIONS = {
  ACCESS_TYPE: ACCESS_TYPES.NORMAL,
  SET_USER: 'SET_USER',
  SET_IP_DETAILS: 'SET_IP_DETAILS',
  LOGIN_USER_LOADING: 'LOGIN_USER_LOADING',
  LOGIN_USER_SUCCESS: 'LOGIN_USER_SUCCESS',
  LOGIN_USER_FAILED: 'LOGIN_USER_FAILED',
  REMOVE_USER: 'REMOVE_USER',
  SET_DATA_CHART_PREFERENCES: 'SET_DATA_CHART_PREFERENCES',
  DATA_CHART_PREFERENCES_RESET: 'DATA_CHART_PREFERENCES_RESET',
  SET_ASPECT_RATIO_PAGE: 'SET_ASPECT_RATIO_PAGE',
  SET_SPEED_CHART_PAGE: 'SET_SPEED_CHART_PAGE',
  SET_MARKETPLACE_INVENTORY_VIEW: 'SET_MARKETPLACE_INVENTORY_VIEW',
  GET_UPDATE_USER_PREFERENCES: 'GET_UPDATE_USER_PREFERENCES',
  SET_UNIT_SYSTEM_USER_PREFERENCES: 'SET_UNIT_SYSTEM_USER_PREFERENCES',
  UPDATE_COLUMNS_USER_PREFERENCES: 'UPDATE_COLUMNS_USER_PREFERENCES',
  SET_CHART_VIEW_MODE: 'SET_CHART_VIEW_MODE',
  SET_TOGGLE_MAPVIEW: 'SET_TOGGLE_MAPVIEW',
  APP_VERSION_DETAILS_SUCCESS: 'APP_VERSION_DETAILS_SUCCESS',
  APP_VERSION_DETAILS_LOADING: 'APP_VERSION_DETAILS_LOADING',
  APP_VERSION_DETAILS_ERROR: 'APP_VERSION_DETAILS_ERROR',

  NEW_USER_LOADING: 'NEW_USER_LOADING',
  NEW_USER_PASSWORD_SUCCESS: 'NEW_USER_PASSWORD_SUCCESS',
  NEW_USER_PASSWORD_FAILED: 'NEW_USER_PASSWORD_FAILED',
  NEW_USER_PASSWORD_LOADED: 'NEW_USER_PASSWORD_LOADED',
  NEW_USER_PASSWORD_ERROR_NOTIFIED: 'NEW_USER_PASSWORD_ERROR_NOTIFIED',

  ALARMS_LIST_LOADING: 'ALARMS_LIST_LOADING',
  ALARMS_LIST_ERROR: 'ALARMS_LIST_ERROR',
  SET_CURRENT_ALARM: 'SET_CURRENT_ALARM',
  ALARMS_LIST_SUCCESS: 'ALARMS_LIST_SUCCESS',
  ALARMS_LIST_ERROR_NOTIFIED: 'ALARMS_LIST_ERROR_NOTIFIED',
  ALARMS_RESET: 'ALARMS_RESET',

  JOBS_LIST_LOADING: 'JOBS_LIST_LOADING',
  JOBS_LIST_ERROR: 'JOBS_LIST_ERROR',
  JOBS_LIST_SUCCESS: 'JOBS_LIST_SUCCESS',
  JOBS_LIST_SINGLE_ITEM_SUCCESS: 'JOBS_LIST_SINGLE_ITEM_SUCCESS',
  JOBS_LIST_ERROR_NOTIFIED: 'JOBS_LIST_ERROR_NOTIFIED',
  JOBS_LIST_SEARCH_CONTROL: 'JOBS_LIST_SEARCH_CONTROL',
  JOBS_RESET: 'JOBS_RESET',
  JOBS_SYNC_LOADING: 'JOBS_SYNC_LOADING',
  JOBS_SYNC_IDLE: 'JOBS_SYNC_IDLE',
  JOBS_SYNC_ERROR: 'JOBS_SYNC_ERROR',

  JOB_ASSETS_LIST_LOADING: 'JOB_ASSETS_LIST_LOADING',
  JOB_ASSETS_LIST_SUCCESS: 'JOB_ASSETS_LIST_SUCCESS',
  JOB_ASSETS_LIST_ERROR: 'JOB_ASSETS_LIST_ERROR',
  JOB_ASSETS_SAVING: 'JOB_ASSETS_SAVING',
  JOB_ASSETS_SAVE_SUCCESS: 'JOB_ASSETS_SAVE_SUCCESS',
  SET_CURRENT_JOB: 'SET_CURRENT_JOB',
  JOB_SIGNALS_LOADING: 'JOB_SIGNALS_LOADING',
  JOB_SIGNALS_LIST_SUCCESS: 'JOB_SIGNALS_LIST_SUCCESS',
  JOB_SIGNALS_LIST_ERROR: 'JOB_SIGNALS_LIST_ERROR',
  JOB_SIGNALS_DATA_LOADING: 'JOB_SIGNALS_DATA_LOADING',
  JOB_SIGNALS_DATA_LIST_SUCCESS: 'JOB_SIGNALS_DATA_LIST_SUCCESS',
  JOB_SIGNALS_DATA_LIST_ERROR: 'JOB_SIGNALS_DATA_LIST_ERROR',
  JOB_ASSETS_SAVE_ERROR: 'JOB_ASSETS_SAVE_ERROR',
  JOBS_FILTER: 'JOBS_FILTER',
  JOBS_SEARCH_CHANGE: 'JOBS_SEARCH_CHANGE',
  JOB_ASSETS_REMOVE_SUCCESS: 'JOB_ASSETS_REMOVE_SUCCESS',
  JOBS_MARKER_FILTER: 'JOB_MARKER_FILTER',
  JOBS_ACTUATOR_UTILIZATION_DATA_SUCCESS: 'JOBS_ACTUATOR_UTILIZATION_DATA_SUCCESS',
  JOBS_ACTUATOR_UTILIZATION_DATA_LOADING: 'JOBS_ACTUATOR_UTILIZATION_DATA_LOADING',
  JOBS_ACTUATOR_UTILIZATION_DATA_ERROR: 'JOBS_ACTUATOR_UTILIZATION_DATA_ERROR',
  JOBS_ACTUATOR_UTILIZATION_SHOW_DATA: 'JOBS_ACTUATOR_UTILIZATION_SHOW_DATA',

  JOBS_CUSTOM_REPORT_LIST_SUCCESS: 'JOBS_CUSTOM_REPORT_LIST_SUCCESS',
  JOBS_CUSTOM_REPORT_LIST_LOADING: 'JOBS_CUSTOM_REPORT_LIST_LOADING',
  JOBS_CUSTOM_REPORT_LIST_ERROR: 'JOBS_CUSTOM_REPORT_LIST_ERROR',
  SET_CURRENT_JOBS_CUSTOM_REPORT: 'SET_CURRENT_JOBS_CUSTOM_REPORT',
  JOBS_CUSTOM_REPORT_LIST_ERROR_NOTIFIED: 'JOBS_CUSTOM_REPORT_LIST_ERROR_NOTIFIED',
  JOBS_CUSTOM_REPORT_RESET: 'JOBS_CUSTOM_REPORT_RESET',

  PARTS_LIST_LOADING: 'PARTS_LIST_LOADING',
  PARTS_LIST_ERROR: 'PARTS_LIST_ERROR',
  PARTS_LIST_SUCCESS: 'PARTS_LIST_SUCCESS',
  PARTS_LIST_ERROR_NOTIFIED: 'PARTS_LIST_ERROR_NOTIFIED',
  PARTS_LIST_SAVING: 'PARTS_LIST_SAVING',
  PARTS_LIST_FILTER: 'PARTS_LIST_FILTER',
  PARTS_LIST_SUGGESTIONS: 'PARTS_LIST_SUGGESTIONS',
  PARTS_LIST_MOBILE_FILTER: 'PARTS_LIST_MOBILE_FILTER',
  PARTS_SEARCH_CHANGE: 'PARTS_SEARCH_CHANGE',
  PARTS_SET_CLASSIFICATION: 'PARTS_SET_CLASSIFICATION',
  PARTS_SET_PRICE: 'PARTS_SET_PRICE',
  PARTS_SET_PRICE_ERROR: 'PARTS_SET_PRICE_ERROR',
  PARTS_RESET: 'PARTS_RESET',
  PARTS_FILTER_BY_COMPANY: 'PARTS_FILTER_BY_COMPANY',
  PARTS_CUSTOMER_LIST_LOADING: 'PARTS_CUSTOMER_LIST_LOADING',
  PARTS_CUSTOMER_LIST_ERROR: 'PARTS_CUSTOMER_LIST_ERROR',
  PARTS_CUSTOMER_LIST_SUCCESS: 'PARTS_CUSTOMER_LIST_SUCCESS',
  PARTS_CUSTOMER_LIST_ERROR_NOTIFIED: 'PARTS_CUSTOMER_LIST_ERROR_NOTIFIED',
  PARTS_SET_FAVORITES: 'PARTS_SET_FAVORITES',
  PARTS_FAVORITES_FILTER: 'PARTS_FAVORITES_FILTER',
  PARTS_FAVORITES_FILTER_RESET: 'PARTS_FAVORITES_FILTER_RESET',

  PART_CATEGORIES_GET_LOADING: 'PART_CATEGORIES_GET_LOADING',
  PART_CATEGORIES_GET_ERROR: 'PART_CATEGORIES_GET_ERROR',
  PART_CATEGORIES_GET_SUCCESS: 'PART_CATEGORIES_GET_SUCCESS',
  PART_CATEGORIES_RESET: 'PART_CATEGORIES_RESET',

  AUDIT_LOGS_LIST_LOADING: 'AUDIT_LOGS_LIST_LOADING',
  AUDIT_LOGS_LIST_SUCCESS: 'AUDIT_LOGS_LIST_SUCCESS',
  AUDIT_LOGS_LIST_ERROR: 'AUDIT_LOGS_LIST_ERROR',
  AUDIT_LOGS_SET_CURRENT_PAGE: 'AUDIT_LOGS_SET_CURRENT_PAGE',
  AUDIT_LOGS_SEARCH_CONTROL: 'AUDIT_LOGS_SEARCH_CONTROL',
  AUDIT_LOGS_SET_FILTER: 'AUDIT_LOGS_SET_FILTER',
  AUDIT_LOGS_SET_SORT: 'AUDIT_LOGS_SET_SORT',

  HYDRAULICS_LOGS_LIST_LOADING: 'HYDRAULICS_LOGS_LIST_LOADING',
  HYDRAULICS_LOGS_LIST_SUCCESS: 'HYDRAULICS_LOGS_LIST_SUCCESS',
  HYDRAULICS_LOGS_LIST_ERROR: 'HYDRAULICS_LOGS_LIST_ERROR',
  HYDRAULICS_LOGS_SET_CURRENT_PAGE: 'HYDRAULICS_LOGS_SET_CURRENT_PAGE',
  HYDRAULICS_LOGS_SEARCH_CONTROL: 'HYDRAULICS_LOGS_SEARCH_CONTROL',
  HYDRAULICS_LOGS_SET_FILTER: 'HYDRAULICS_LOGS_SET_FILTER',
  HYDRAULICS_LOGS_SET_SORT: 'HYDRAULICS_LOGS_SET_SORT',

  MARKETPLACE_LOGS_LIST_LOADING: 'MARKETPLACE_LOGS_LIST_LOADING',
  MARKETPLACE_LOGS_LIST_SUCCESS: 'MARKETPLACE_LOGS_LIST_SUCCESS',
  MARKETPLACE_LOGS_LIST_ERROR: 'MARKETPLACE_LOGS_LIST_ERROR',
  MARKETPLACE_LOGS_SET_CURRENT_PAGE: 'MARKETPLACE_LOGS_SET_CURRENT_PAGE',
  MARKETPLACE_LOGS_SEARCH_CONTROL: 'MARKETPLACE_LOGS_SEARCH_CONTROL',
  MARKETPLACE_LOGS_SET_FILTER: 'MARKETPLACE_LOGS_SET_FILTER',
  MARKETPLACE_LOGS_SET_SORT: 'MARKETPLACE_LOGS_SET_SORT',

  TRANSACTION_HISTORY_LIST_LOADING: 'TRANSACTION_HISTORY_LIST_LOADING',
  TRANSACTION_HISTORY_KPIS_LOADING: 'TRANSACTION_HISTORY_KPIS_LOADING',
  TRANSACTION_HISTORY_DIVISION_KPIS_LOADING: 'TRANSACTION_HISTORY_DIVISION_KPIS_LOADING',
  TRANSACTION_HISTORY_LIST_SUCCESS: 'TRANSACTION_HISTORY_LIST_SUCCESS',
  TRANSACTION_HISTORY_KPIS_SUCCESS: 'TRANSACTION_HISTORY_KPIS_SUCCESS',
  TRANSACTION_HISTORY_DIVISION_KPIS_SUCCESS: 'TRANSACTION_HISTORY_DIVISION_KPIS_SUCCESS',
  TRANSACTION_HISTORY_LIST_ERROR: 'TRANSACTION_HISTORY_LIST_ERROR',
  TRANSACTION_HISTORY_KPIS_ERROR: 'TRANSACTION_HISTORY_KPIS_ERROR',
  TRANSACTION_HISTORY_DIVISION_KPIS_ERROR: 'TRANSACTION_HISTORY_DIVISION_KPIS_ERROR',
  TRANSACTION_HISTORY_ORDER_NUM: 'TRANSACTION_HISTORY_ORDER_NUM',
  TRANSACTION_HISTORY_SEARCH_CONTROL: 'TRANSACTION_HISTORY_SEARCH_CONTROL',
  TRANSACTION_HISTORY_PRINT_STATE: 'TRANSACTION_HISTORY_PRINT_STATE',
  TRANSACTION_HISTORY_SET_CURRENT_PAGE: 'TRANSACTION_HISTORY_SET_CURRENT_PAGE',
  TRANSACTION_HISTORY_SET_FILTER: 'TRANSACTION_HISTORY_SET_FILTER',
  TRANSACTION_HISTORY_SET_SORT: 'TRANSACTION_HISTORY_SET_SORT',

  USER_BUGS_LIST_LOADING: 'USER_BUGS_LIST_LOADING',
  USER_BUGS_LIST_SUCCESS: 'USER_BUGS_LIST_SUCCESS',
  USER_BUGS_LIST_ERROR: 'USER_BUGS_LIST_ERROR',
  USER_BUGS_SET_CURRENT_PAGE: 'USER_BUGS_SET_CURRENT_PAGE',
  USER_BUGS_SET_FILTER: 'USER_BUGS_SET_FILTER',
  USER_BUGS_SET_SORT: 'USER_BUGS_SET_SORT',
  USER_BUGS_SEARCH_CONTROL: 'USER_BUGS_SEARCH_CONTROL',

  MARKETPLACE_TRANSACTION_LIST_LOADING: 'MARKETPLACE_TRANSACTION_LIST_LOADING',
  MARKETPLACE_TRANSACTION_LIST_ERROR: 'MARKETPLACE_TRANSACTION_LIST_ERROR',
  MARKETPLACE_TRANSACTION_SET_LIST: 'MARKETPLACE_TRANSACTION_SET_LIST',

  ALARM_HISTORY_LIST_LOADING: 'ALARM_HISTORY_LIST_LOADING',
  ALARM_HISTORY_LIST_SUCCESS: 'ALARM_HISTORY_LIST_SUCCESS',
  ALARM_HISTORY_LIST_ERROR: 'ALARM_HISTORY_LIST_ERROR',
  ALARM_HISTORY_SET_CURRENT_PAGE: 'ALARM_HISTORY_SET_CURRENT_PAGE',
  ALARM_HISTORY_SEARCH_CONTROL: 'ALARM_HISTORY_SEARCH_CONTROL',
  ALARM_HISTORY_SET_FILTER: 'ALARM_HISTORY_SET_FILTER',
  ALARM_HISTORY_SET_SORT: 'ALARM_HISTORY_SET_SORT',

  COMPANIES_LIST_LOADING: 'COMPANIES_LIST_LOADING',
  COMPANIES_LIST_ERROR: 'COMPANIES_LIST_ERROR',
  COMPANIES_LIST_SUCCESS: 'COMPANIES_LIST_SUCCESS',
  COMPANIES_LIST_CLEAR: 'COMPANIES_LIST_CLEAR',
  COMPANIES_LIST_ERROR_NOTIFIED: 'COMPANIES_LIST_ERROR_NOTIFIED',
  COMPANIES_RESET: 'COMPANIES_RESET',
  COMPANIES_ADD_DISABLE: 'COMPANIES_ADD_DISABLE',

  SPEND_CHART_DATA_LOADING: 'SPEND_CHART_DATA_LOADING',
  SPEND_CHART_DATA_ERROR: 'SPEND_CHART_DATA_ERROR',
  SPEND_CHART_DATA: 'SPEND_CHART_DATA',
  SPEND_CHART_SET_FILTER_TYPE: 'SPEND_CHART_SET_FILTER_TYPE',
  SPEND_CHART_RESET: 'SPEND_CHART_RESET',

  SPEND_VENDORS_LOADING: 'SPEND_VENDORS_LOADING',
  SPEND_VENDORS_ERROR: 'SPEND_VENDORS_ERROR',
  SPEND_VENDORS_DATA: 'SPEND_VENDORS_DATA',
  SPEND_VENDORS_RESET: 'SPEND_VENDORS_RESET',
  SPEND_VENDORS_SET_SELECTED: 'SPEND_VENDORS_SET_SELECTED',

  FAVORITE_PARTS_DATA_LOADING: 'FAVORITE_PARTS_DATA_LOADING',
  FAVORITE_PARTS_DATA_ERROR: 'FAVORITE_PARTS_DATA_ERROR',
  FAVORITE_PARTS_DATA_SUCCESS: 'FAVORITE_PARTS_DATA_SUCCESS',

  MARKETPLACE_FEATURED_LIST_LOADING: 'MARKETPLACE_FEATURED_LIST_LOADING',
  MARKETPLACE_FEATURED_LIST_SUCCESS: 'MARKETPLACE_FEATURED_LIST_SUCCESS',

  MARKETPLACE_SEARCH_LOADING: 'MARKETPLACE_SEARCH_LOADING',
  MARKETPLACE_SEARCH_SUCCESS: 'MARKETPLACE_SEARCH_SUCCESS',
  MARKETPLACE_SEARCH_ERROR: 'MARKETPLACE_SEARCH_ERROR',
  MARKETPLACE_SEARCH_RESET: 'MARKETPLACE_SEARCH_RESET',
  MARKETPLACE_SEARCH_LOAD_NEXT: 'MARKETPLACE_SEARCH_LOAD_NEXT',

  ORDERS_LIST_LOADING: 'ORDERS_LIST_LOADING',
  ORDERS_LIST_ERROR: 'ORDERS_LIST_ERROR',
  ORDERS_LIST_SUCCESS: 'ORDERS_LIST_SUCCESS',
  ORDERS_LIST_UPDATE: 'ORDERS_LIST_UPDATE',
  ORDERS_LIST_ERROR_NOTIFIED: 'ORDERS_LIST_ERROR_NOTIFIED',
  ORDERS_SET_GREEN_LIST: 'ORDERS_SET_GREEN_LIST',
  ORDERS_SET_GREEN_ITEM_NOT_FOUND: 'ORDERS_SET_GREEN_ITEM_NOT_FOUND',
  ORDERS_SET_GRAY_LIST: 'ORDERS_SET_GRAY_LIST',
  ORDERS_SET_GRAY_ITEM_NOT_FOUND: 'ORDERS_SET_GRAY_ITEM_NOT_FOUND',
  ORDERS_RESET: 'ORDERS_RESET',
  ORDERS_SET_GREEN_PARTS_DETAILS_SUCCESS:
    'ORDERS_SET_GREEN_PARTS_DETAILS_SUCCESS',
  ORDERS_GREEN_PARTS_DETAILS_LOADING: 'ORDERS_GREEN_PARTS_DETAILS_LOADING',
  ORDERS_GREEN_PARTS_ERROR_NOTIFIED: 'ORDERS_GREEN_PARTS_ERROR_NOTIFIED',
  ORDER_PARTS_POSTING: 'ORDER_PARTS_POSTING',
  ORDER_PARTS_POST_SUCCESS: 'ORDER_PARTS_POST_SUCCESS',
  ORDER_PARTS_POST_ERROR: 'ORDER_PARTS_POST_ERROR',

  QUOTES_LIST_LOADING: 'QUOTES_LIST_LOADING',
  QUOTES_LIST_ERROR: 'QUOTES_LIST_ERROR',
  QUOTES_LIST_SUCCESS: 'QUOTES_LIST_SUCCESS',
  QUOTES_LIST_ERROR_NOTIFIED: 'QUOTES_LIST_ERROR_NOTIFIED',
  QUOTES_RESET: 'QUOTES_RESET',
  QUOTES_SET_GRAY_PARTS_DETAILS_SUCCESS:
    'QUOTES_SET_GRAY_PARTS_DETAILS_SUCCESS',
  QUOTES_GRAY_PARTS_DETAILS_LOADING: 'QUOTES_GRAY_PARTS_DETAILS_LOADING',
  QUOTES_GRAY_PARTS_ERROR_NOTIFIED: 'QUOTES_GRAY_PARTS_ERROR_NOTIFIED',
  QUOTE_PARTS_POSTING: 'QUOTE_PARTS_POSTING',
  QUOTE_PARTS_POST_SUCCESS: 'QUOTE_PARTS_POST_SUCCESS',
  QUOTE_PARTS_POST_ERROR: 'QUOTE_PARTS_POST_ERROR',
  SET_SHOPPING_CART_PREFERENCES: 'SET_SHOPPING_CART_PREFERENCES',

  TICKETS_LIST_LOADING: 'TICKETS_LIST_LOADING',
  SET_TICKETS_LIST: 'SET_TICKETS_LIST',
  TICKETS_LIST_ERROR: 'TICKETS_LIST_ERROR',
  TICKETS_RESET: 'TICKETS_RESET',

  SELLERS_LIST_LOADING: 'SELLERS_LIST_LOADING',
  SELLERS_LIST_SUCCESS: 'SELLERS_LIST_SUCCESS',
  SELLERS_LIST_ERROR: 'SELLERS_LIST_ERROR',
  SELLERS_LIST_ERROR_NOTIFIED: 'SELLERS_LIST_ERROR_NOTIFIED',
  SELLERS_RESET: 'SELLERS_RESET',

  USERS_LIST_LOADING: 'USERS_LIST_LOADING',
  USERS_LIST_ERROR: 'USERS_LIST_ERROR',
  USERS_LIST_SUCCESS: 'USERS_LIST_SUCCESS',
  USERS_LIST_ERROR_NOTIFIED: 'USERS_LIST_ERROR_NOTIFIED',
  USERS_RESET: 'USERS_RESET',
  USERS_ADD_DISABLE: 'USERS_ADD_DISABLE',

  ALARMS_RECIPIENTS_USERS_LIST_LOADING: 'ALARMS_RECIPIENTS_USERS_LIST_LOADING',
  ALARMS_RECIPIENTS_USERS_LIST_ERROR: 'ALARMS_RECIPIENTS_USERS_LIST_ERROR',
  ALARMS_RECIPIENTS_USERS_LIST_SUCCESS: 'ALARMS_RECIPIENTS_USERS_LIST_SUCCESS',

  COMPANIES_USERS_LIST_LOADING: 'COMPANIES_USERS_LIST_LOADING',
  COMPANIES_USERS_LIST_ERROR: 'COMPANIES_USERS_LIST_ERROR',
  COMPANIES_USERS_LIST_SUCCESS: 'COMPANIES_USERS_LIST_SUCCESS',
  COMPANIES_USERS_LIST_ERROR_NOTIFIED: 'COMPANIES_USERS_LIST_ERROR_NOTIFIED',
  COMPANIES_USERS_RESET: 'COMPANIES_USERS_RESET',

  SALES_REPS_LIST_LOADING: 'SALES_REPS_LIST_LOADING',
  SALES_REPS_LIST_ERROR: 'SALES_REPS_LIST_ERROR',
  SALES_REPS_LIST_SUCCESS: 'SALES_REPS_LIST_SUCCESS',
  SALES_REPS_RESET: 'SALES_REPS_RESET',

  USERS_POD_UPLOAD_LOADING: 'USERS_POD_ LOADING',
  USERS_POD_UPLOAD_ERROR: 'USERS_POD_ERROR',
  USERS_POD_UPLOAD_SUCCESS: 'USERS_POD_SUCCESS',
  USERS_POD_UPLOAD_ERROR_NOTIFIED: 'USERS_POD_ERROR_NOTIFIED',
  USERS_SET_POD: 'USERS_SET_POD',

  ASSET_DATA_LOADING: 'ASSET_DATA_LOADING',
  ASSET_DATA_ERROR: 'ASSET_DATA_ERROR',
  ASSET_DATA_SUCCESS: 'ASSET_DATA_SUCCESS',
  ASSET_DATA_ERROR_NOTIFIED: 'ASSET_DATA_ERROR_NOTIFIED',
  ASSET_DATA_RESET: 'ASSET_DATA_RESET',
  ASSET_DATA_SET_PRESET: 'ASSET_DATA_SET_PRESET',
  ASSET_DATA_SET_DATES: 'ASSET_DATA_SET_DATES',
  ASSET_DATA_TOOGLE_DATES_MODAL: 'ASSET_DATA_TOOGLE_DATES_MODAL',
  ASSET_DATA_TOOGLE_PAUSE: 'ASSET_DATA_TOOGLE_PAUSE',
  ASSET_DATA_PAUSE: 'ASSET_DATA_PAUSE',
  ASSET_DATA_TAG_POST: 'ASSET_DATA_TAG_POST',
  ASSET_DATA_SET_LAST_DATE: 'ASSET_DATA_SET_LAST_DATE',

  EVENTS_DATA_SUCCESS: 'EVENTS_DATA_SUCCESS',
  EVENTS_DATA_LOADING: 'EVENTS_DATA_LOADING',

  ASSETS_LOADING: 'ASSETS_LOADING',
  ASSETS_SUCCESS: 'ASSETS_SUCCESS',
  ASSETS_ERROR: 'ASSETS_ERROR',
  ASSETS_ERROR_NOTIFIED: 'ASSETS_ERROR_NOTIFIED',
  ASSETS_RESET: 'ASSETS_RESET',
  ASSETS_SAVE_JOB_ASSET_SUCCESS: 'ASSET_DATA_SAVE_ASSET_SUCCESS',
  ASSETS_REMOVE_JOB_ASSET_SUCCESS: 'ASSETS_REMOVE_JOB_ASSET_SUCCESS',

  ASSETS_LIST_LOADING: 'ASSETS_LIST_LOADING',
  ASSETS_LIST_SUCCESS: 'ASSETS_LIST_SUCCESS',
  ASSETS_LIST_FIRST_PROPERTY: 'ASSETS_LIST_FIRST_PROPERTY',
  ASSETS_LIST_ERROR: 'ASSETS_LIST_ERROR',
  ASSETS_LIST_RESET: 'ASSETS_LIST_RESET',
  ASSETS_LIST_FILTER: 'ASSETS_LIST_FILTER',
  ASSETS_LIST_SEARCH_CHANGE: 'ASSETS_LIST_SEARCH_CHANGE',

  EPICOR_PARTS_LIST_LOADING: 'EPICOR_PARTS_LIST_LOADING',
  EPICOR_PARTS_LIST_ERROR: 'EPICOR_PARTS_LIST_ERROR',
  EPICOR_PARTS_LIST_SUCCESS: 'EPICOR_PARTS_LIST_SUCCESS',
  EPICOR_PARTS_LIST_ERROR_NOTIFIED: 'EPICOR_PARTS_LIST_ERROR_NOTIFIED',
  EPICOR_PARTS_RESET: 'EPICOR_PARTS_RESET',
  EPICOR_PARTS_SEARCH: 'EPICOR_PARTS_SEARCH',

  EPICOR_CUSTOMERS_LIST_LOADING: 'EPICOR_CUSTOMERS_LIST_LOADING',
  EPICOR_CUSTOMERS_LIST_ERROR: 'EPICOR_CUSTOMERS_LIST_ERROR',
  EPICOR_CUSTOMERS_LIST_SUCCESS: 'EPICOR_CUSTOMERS_LIST_SUCCESS',
  EPICOR_CUSTOMERS_LIST_ERROR_NOTIFIED: 'EPICOR_CUSTOMERS_LIST_ERROR_NOTIFIED',
  EPICOR_CUSTOMERS_RESET: 'EPICOR_CUSTOMERS_RESET',
  EPICOR_CUSTOMERS_SEARCH: 'EPICOR_CUSTOMERS_SEARCH',

  EPICOR_PRICE_LISTS_LIST_LOADING: 'EPICOR_PRICE_LISTS_LIST_LOADING',
  EPICOR_PRICE_LISTS_LIST_SUCCESS: 'EPICOR_PRICE_LISTS_LIST_SUCCESS',
  EPICOR_PRICE_LISTS_LIST_ERROR: 'EPICOR_PRICE_LISTS_LIST_ERROR',
  EPICOR_PRICE_LISTS_LIST_ERROR_NOTIFIED:
    'EPICOR_PRICE_LISTS_LIST_ERROR_NOTIFIED',
  EPICOR_PRICE_LISTS_SEARCH: 'EPICOR_PRICE_LISTS_SEARCH',
  EPICOR_PRICE_LISTS_RESET: 'EPICOR_PRICE_LISTS_RESET',

  EPICOR_SALE_ORDERS_LIST_LOADING: 'EPICOR_SALE_ORDERS_LIST_LOADING',
  EPICOR_SALE_ORDERS_LIST_SUCCESS: 'EPICOR_SALE_ORDERS_LIST_SUCCESS',
  EPICOR_SALE_ORDERS_LIST_ERROR: 'EPICOR_SALE_ORDERS_LIST_ERROR',
  EPICOR_SALE_ORDERS_LIST_ERROR_NOTIFIED:
    'EPICOR_SALE_ORDERS_LIST_ERROR_NOTIFIED',
  EPICOR_SALE_ORDERS_SEARCH: 'EPICOR_SALE_ORDERS_SEARCH',
  EPICOR_SALE_ORDERS_RESET: 'EPICOR_SALE_ORDERS_RESET',

  EPICOR_SALE_ORDERS_POSTING: 'EPICOR_SALE_ORDERS_POSTING',
  EPICOR_SALE_ORDERS_POST_SUCCESS: 'EPICOR_SALE_ORDERS_POST_SUCCESS',
  EPICOR_SALE_ORDERS_POST_ERROR: 'EPICOR_SALE_ORDERS_POST_ERROR',

  EPICOR_WORK_FORCE_LIST_LOADING: 'EPICOR_WORK_FORCE_LIST_LOADING',
  EPICOR_WORK_FORCE_LIST_SUCCESS: 'EPICOR_WORK_FORCE_LIST_SUCCESS',
  EPICOR_WORK_FORCE_LIST_ERROR: 'EPICOR_WORK_FORCE_LIST_ERROR',
  EPICOR_WORK_FORCE_LIST_ERROR_NOTIFIED:
    'EPICOR_WORK_FORCE_LIST_ERROR_NOTIFIED',
  EPICOR_WORK_FORCE_SEARCH: 'EPICOR_WORK_FORCE_SEARCH',
  EPICOR_WORK_FORCE_RESET: 'EPICOR_WORK_FORCE_RESET',

  EPICOR_BINS_LIST_LOADING: 'EPICOR_BINS_LIST_LOADING',
  EPICOR_BINS_LIST_ERROR: 'EPICOR_BINS_LIST_ERROR',
  EPICOR_BINS_LIST_SUCCESS: 'EPICOR_BINS_LIST_SUCCESS',
  EPICOR_BINS_LIST_ERROR_NOTIFIED: 'EPICOR_BINS_LIST_ERROR_NOTIFIED',
  EPICOR_BINS_RESET: 'EPICOR_BINS_RESET',
  EPICOR_BINS_FILTER: 'EPICOR_BINS_FILTER',
  EPICOR_BINS_SEARCH_CHANGE: 'EPICOR_BINS_SEARCH_CHANGE',
  EPICOR_BINS_SEARCH: 'EPICOR_BINS_SEARCH',

  FIELDBOXES_KPIS_LIST_LOADING: 'FIELDBOXES_KPIS_LIST_LOADING',
  FIELDBOXES_KPIS_LIST_ERROR: 'FIELDBOXES_KPIS_LIST_ERROR',
  FIELDBOXES_KPIS_LIST_SUCCESS: 'FIELDBOXES_KPIS_LIST_SUCCESS',
  FIELDBOXES_KPIS_SET_DIVISION: 'FIELDBOXES_KPIS_SET_DIVISION',
  FIELDBOXES_KPIS_LIST_FILTER: 'FIELDBOXES_KPIS_LIST_FILTER',
  FIELDBOXES_KPIS_LIST_SEARCH_CHANGE: 'FIELDBOXES_KPIS_LIST_SEARCH_CHANGE',

  MARKETSHARE_KPIS_LIST_LOADING: 'MARKETSHARE_KPIS_LIST_LOADING',
  MARKETSHARE_KPIS_LIST_ERROR: 'MARKETSHARE_KPIS_LIST_ERROR',
  MARKETSHARE_KPIS_LIST_SUCCESS: 'MARKETSHARE_KPIS_LIST_SUCCESS',
  MARKETSHARE_KPIS_SET_DIVISION: 'MARKETSHARE_KPIS_SET_DIVISION',
  MARKETSHARE_KPIS_LIST_SEARCH_CHANGE: 'MARKETSHARE_KPIS_LIST_SEARCH_CHANGE',

  EPICOR_TRUCKS_LIST_LOADING: 'EPICOR_TRUCKS_LIST_LOADING',
  EPICOR_TRUCKS_LIST_ERROR: 'EPICOR_TRUCKS_LIST_ERROR',
  EPICOR_TRUCKS_LIST_SUCCESS: 'EPICOR_TRUCKS_LIST_SUCCESS',
  EPICOR_TRUCKS_LIST_ERROR_NOTIFIED: 'EPICOR_TRUCKS_LIST_ERROR_NOTIFIED',
  EPICOR_TRUCKS_RESET: 'EPICOR_TRUCKS_RESET',

  EPICOR_SET_SELECTED_ROWS: 'EPICOR_SET_SELECTED_ROWS',
  EPICOR_RELEASES_LIST_LOADING: 'EPICOR_RELEASES_LIST_LOADING',
  EPICOR_RELEASES_LIST_SUCCESS: 'EPICOR_RELEASES_LIST_SUCCESS',
  EPICOR_RELEASES_LIST_ERROR: 'EPICOR_RELEASES_LIST_ERROR',
  EPICOR_RELEASES_RESET: 'EPICOR_RELEASES_RESET',

  EPICOR_ORDER_DETAILS_LOADING: 'EPICOR_ORDER_DETAILS_LOADING',
  EPICOR_ORDER_DETAILS_SUCCESS: 'EPICOR_ORDER_DETAILS_SUCCESS',
  EPICOR_ORDER_DETAILS_ERROR: 'EPICOR_ORDER_DETAILS_ERROR',
  EPICOR_ORDER_DETAILS_RESET: 'EPICOR_ORDER_DETAILS_RESET',

  EPICOR_BINS_PARTS_LOADING: 'EPICOR_BINS_PARTS_LOADING',
  EPICOR_BINS_PARTS_ERROR: 'EPICOR_BINS_PARTS_ERROR',
  EPICOR_BINS_PARTS_SUCCESS: 'EPICOR_BINS_PARTS_SUCCESS',
  EPICOR_BINS_PARTS_ERROR_NOTIFIED: 'EPICOR_BINS_PARTS_ERROR_NOTIFIED',

  EPICOR_REPORTS_INVENTORY_PDF_REQUEST: 'EPICOR_REPORTS_INVENTORY_PDF_REQUEST',
  EPICOR_REPORTS_INVENTORY_PDF_LOADING: 'EPICOR_REPORTS_INVENTORY_PDF_LOADING',
  EPICOR_REPORTS_INVENTORY_PDF_SUCCESS: 'EPICOR_REPORTS_INVENTORY_PDF_SUCCESS',
  EPICOR_REPORTS_INVENTORY_PDF_ERROR: 'EPICOR_REPORTS_INVENTORY_PDF_ERROR',
  EPICOR_REPORTS_INVENTORY_PDF_ERROR_NOTIFIED:
    'EPICOR_REPORTS_INVENTORY_PDF_ERROR_NOTIFIED',

  EPICOR_SYNC_MOBILE_DATA_LOADING: 'EPICOR_SYNC_MOBILE_DATA_LOADING',
  EPICOR_SYNC_MOBILE_DATA_IDLE: 'EPICOR_SYNC_MOBILE_DATA_IDLE',
  EPICOR_SYNC_MOBILE_DATA_ERROR: 'EPICOR_SYNC_MOBILE_DATA_ERROR',

  EPICOR_SEND_BIN_REMINDERS_LOADING: 'EPICOR_SEND_BIN_REMINDERS_LOADING',
  EPICOR_SEND_BIN_REMINDERS_IDLE: 'EPICOR_SEND_BIN_REMINDERS_IDLE',
  EPICOR_SEND_BIN_REMINDERS_ERROR: 'EPICOR_SEND_BIN_REMINDERS_ERROR',
  EPICOR_SEND_BIN_REMINDERS_SUCCESS: 'EPICOR_SEND_BIN_REMINDERS_SUCCESS',

  EPICOR_SYNC_SIGNATURE_HARVEST_LOADING: 'EPICOR_SYNC_SIGNATURE_HARVEST_LOADING',
  EPICOR_SYNC_SIGNATURE_HARVEST_IDLE: 'EPICOR_SYNC_SIGNATURE_HARVEST_IDLE',
  EPICOR_SYNC_SIGNATURE_HARVEST_ERROR: 'EPICOR_SYNC_SIGNATURE_HARVEST_ERROR',
  EPICOR_SYNC_SIGNATURE_HARVEST_SUCCESS: 'EPICOR_SYNC_SIGNATURE_HARVEST_SUCCESS',
  EPICOR_SYNC_SIGNATURE_HARVEST_DIVISION: 'EPICOR_SYNC_SIGNATURE_HARVEST_DIVISION',

  EPICOR_SYNC_BIN_LOADING: 'EPICOR_SYNC_BIN_LOADING',
  EPICOR_SYNC_BIN_IDLE: 'EPICORE_SYNC_BIN_IDLE',
  EPICOR_SYNC_BIN_ERROR: 'EPICORE_SYNC_BIN_ERROR',
  EPICOR_UPDATE_COORDINATES: 'EPICOR_BIN_UPDATE_COORDINATES',
  EPICOR_SYNC_TRUCK_LOADING: 'EPICOR_SYNC_TRUCK_LOADING',
  EPICOR_SYNC_TRUCK_IDLE: 'EPICORE_SYNC_TRUCK_IDLE',
  EPICOR_SYNC_TRUCK_ERROR: 'EPICORE_SYNC_TRUCK_ERROR',
  EPICOR_TOKEN_REFRESH_ERROR: 'EPICOR_TOKEN_REFRESH_ERROR',

  EPICORE_RIGS_SYNC_SHIPSTO_LOADING: 'EPICORE_RIGS_SYNC_SHIPSTO_LOADING',
  EPICORE_RIGS_SYNC_SHIPSTO_IDLE: 'EPICORE_RIGS_SYNC_SHIPSTO_IDLE',
  EPICORE_RIGS_SYNC_SHIPSTO_ERROR: 'EPICORE_RIGS_SYNC_SHIPSTO_ERROR',
  EPICOR_RIGS_SYNC_CUSTOMERS_LOADING: 'EPICOR_RIGS_SYNC_CUSTOMERS_LOADING',
  EPICOR_RIGS_SYNC_CUSTOMERS_IDLE: 'EPICOR_RIGS_SYNC_CUSTOMERS_IDLE',
  EPICOR_RIGS_SYNC_CUSTOMERS_ERROR: 'EPICOR_RIGS_SYNC_CUSTOMERS_ERROR',

  USER_LOGOUT: 'USER_LOGOUT',

  SNACKBAR_ENQUEUE: 'SNACKBAR_ENQUEUE',
  SNACKBAR_CLOSE: 'SNACKBAR_CLOSE',
  SNACKBAR_REMOVE: 'SNACKBAR_REMOVE',

  DATA_LOADING: 'DATA_LOADING',
  DATA_LOADING_ENDED: 'DATA_LOADING_ENDED',

  SEND_PASSWORD_RESET_EMAIL_LOADING: 'SEND_PASSWORD_RESET_EMAIL_LOADING',
  SEND_PASSWORD_RESET_EMAIL_SUCCESS: 'SEND_PASSWORD_RESET_EMAIL_SUCCESS',
  SEND_PASSWORD_RESET_EMAIL_FAILED: 'SEND_PASSWORD_RESET_EMAIL_FAILED',
  SEND_PASSWORD_RESET_EMAIL_RESET: 'SEND_PASSWORD_RESET_EMAIL_RESET',

  RESET_PASSWORD_LOADING: 'RESET_PASSWORD_LOADING',
  RESET_PASSWORD_SUCCESS: 'RESET_PASSWORD_SUCCESS',
  RESET_PASSWORD_FAILED: 'RESET_PASSWORD_FAILED',
  RESET_PASSWORD_RESET: 'RESET_PASSWORD_RESET',

  SEND_SIGN_UP_REQUEST_LOADING: 'SEND_SIGN_UP_REQUEST_LOADING',
  SEND_SIGN_UP_REQUEST_SUCCESS: 'SEND_SIGN_UP_REQUEST_SUCCESS',
  SEND_SIGN_UP_REQUEST_FAILED: 'SEND_SIGN_UP_REQUEST_FAILED',
  SEND_SIGN_UP_REQUEST_RESET: 'SEND_SIGN_UP_REQUEST_RESET',

  CREATE_ACTUATOR_REPORT_REQUEST: 'CREATE_ACTUATOR_REPORT_REQUEST',
  CREATE_ACTUATOR_REPORT_SUCCESS: 'CREATE_ACTUATOR_REPORT_SUCCESS',
  CREATE_ACTUATOR_REPORT_FAILURE: 'CREATE_ACTUATOR_REPORT_FAILURE',

  MENU_SET_TITLE: 'MENU_SET_TITLE',
  SEARCHBOX_SET_TERMS: 'SEARCHBOX_SET_TERMS',
  MENU_SET_TAB: 'MENU_SET_TAB',

  DOWNLOAD_ORDER_IDLE: 'DOWNLOAD_ORDER_IDLE',
  DOWNLOAD_ORDER_LOADING: 'DOWNLOAD_ORDER_LOADING',
  DOWNLOAD_ORDER_ERROR: 'DOWNLOAD_ORDER_ERROR',

  DOWNLOAD_QUOTE_IDLE: 'DOWNLOAD_QUOTE_IDLE',
  DOWNLOAD_QUOTE_LOADING: 'DOWNLOAD_QUOTE_LOADING',
  DOWNLOAD_QUOTE_ERROR: 'DOWNLOAD_QUOTE_ERROR',

  WELLS_LIST_LOADING: 'WELLS_LIST_LOADING',
  WELLS_LIST_ERROR: 'WELLS_LIST_ERROR',
  WELLS_LIST_SUCCESS: 'WELLS_LIST_SUCCESS',
  WELLS_RESET: 'WELLS_RESET',
  WELLS_FILTER: 'WELLS_FILTER',
  WELLS_MARKER_FILTER: 'WELLS_MARKER_FILTER',
  WELLS_SEARCH_CHANGE: 'WELLS_SEARCH_CHANGE',
  WELLS_SAVE_DETAILS: 'WELLS_SAVE_DETAILS',

  WELLS_SURVEY_LIST_LOADING: 'WELLS_SURVEY_LIST_LOADING',
  WELLS_SURVEY_LIST_ERROR: 'WELLS_SURVEY_LIST_ERROR',
  WELLS_SURVEY_LIST_SUCCESS: 'WELLS_SURVEY_LIST_SUCCESS',
  WELLS_SURVEY_LIST_ERROR_NOTIFIED: 'WELLS_SURVEY_LIST_ERROR_NOTIFIED',
  WELLS_SURVEY_RESET: 'WELLS_SURVEY_RESET',

  WELLS_GEOMETRY_LIST_LOADING: 'WELLS_GEOMETRY_LIST_LOADING',
  WELLS_GEOMETRY_LIST_ERROR: 'WELLS_GEOMETRY_LIST_ERROR',
  WELLS_GEOMETRY_LIST_SUCCESS: 'WELLS_GEOMETRY_LIST_SUCCESS',
  WELLS_GEOMETRY_LIST_ERROR_NOTIFIED: 'WELLS_GEOMETRY_LIST_ERROR_NOTIFIED',
  WELLS_GEOMETRY_RESET: 'WELLS_GEOMETRY_RESET',

  WELLS_DRILL_STRING_LIST_LOADING: 'WELLS_DRILL_STRING_LIST_LOADING',
  WELLS_DRILL_STRING_LIST_ERROR: 'WELLS_DRILL_STRING_LIST_ERROR',
  WELLS_DRILL_STRING_LIST_SUCCESS: 'WELLS_DRILL_STRING_LIST_SUCCESS',
  WELLS_DRILL_STRING_LIST_ERROR_NOTIFIED: 'WELLS_DRILL_STRING_LIST_ERROR_NOTIFIED',
  WELLS_DRILL_STRING_RESET: 'WELLS_DRILL_STRING_RESET',
  WELLS_DRILL_STRING_SET_ID: 'WELLS_DRILL_STRING_SET_ID',

  WELLS_DRILL_STRING_DETAILS_LIST_LOADING: 'WELLS_DRILL_STRING_DETAILS_LIST_LOADING',
  WELLS_DRILL_STRING_DETAILS_LIST_ERROR: 'WELLS_DRILL_STRING_DETAILS_LIST_ERROR',
  WELLS_DRILL_STRING_DETAILS_LIST_SUCCESS: 'WELLS_DRILL_STRING_DETAILS_LIST_SUCCESS',

  WELLS_DRILL_STRING_BIT_DETAILS_LIST_LOADING: 'WELLS_DRILL_STRING_BIT_DETAILS_LIST_LOADING',
  WELLS_DRILL_STRING_BIT_DETAILS_LIST_ERROR: 'WELLS_DRILL_STRING_BIT_DETAILS_LIST_ERROR',
  WELLS_DRILL_STRING_BIT_DETAILS_LIST_SUCCESS: 'WELLS_DRILL_STRING_BIT_DETAILS_LIST_SUCCESS',

  WELLS_DRILL_FLUID_LIST_LOADING: 'WELLS_DRILL_FLUID_LIST_LOADING',
  WELLS_DRILL_FLUID_LIST_ERROR: 'WELLS_DRILL_FLUID_LIST_ERROR',
  WELLS_DRILL_FLUID_LIST_SUCCESS: 'WELLS_DRILL_FLUID_LIST_SUCCESS',
  WELLS_DRILL_FLUID_LIST_ERROR_NOTIFIED: 'WELLS_DRILL_FLUID_LIST_ERROR_NOTIFIED',
  WELLS_DRILL_FLUID_RESET: 'WELLS_DRILL_FLUID_RESET',
  WELLS_DRILL_FLUID_SET_ID: 'WELLS_DRILL_FLUID_SET_ID',

  WELLS_DRILL_FLUID_DETAILS_LIST_LOADING: 'WELLS_DRILL_FLUID_DETAILS_LIST_LOADING',
  WELLS_DRILL_FLUID_DETAILS_LIST_ERROR: 'WELLS_DRILL_FLUID_DETAILS_LIST_ERROR',
  WELLS_DRILL_FLUID_DETAILS_LIST_SUCCESS: 'WELLS_DRILL_FLUID_DETAILS_LIST_SUCCESS',

  WELLS_WINDOW_LIST_LOADING: 'WELLS_WINDOW_LIST_LOADING',
  WELLS_WINDOW_LIST_ERROR: 'WELLS_WINDOW_LIST_ERROR',
  WELLS_WINDOW_LIST_SUCCESS: 'WELLS_WINDOW_LIST_SUCCESS',
  WELLS_WINDOW_LIST_ERROR_NOTIFIED: 'WELLS_WINDOW_LIST_ERROR_NOTIFIED',
  WELLS_WINDOW_RESET: 'WELLS_WINDOW_RESET',

  RIGS_LIST_LOADING: 'RIGS_LIST_LOADING',
  RIGS_LIST_ERROR: 'RIGS_LIST_ERROR',
  RIGS_LIST_SUCCESS: 'RIGS_LIST_SUCCESS',
  RIGS_RESET: 'RIGS_RESET',
  RIGS_FILTER: 'RIGS_FILTER',
  RIGS_MARKER_FILTER: 'RIGS_MARKER_FILTER',
  RIGS_SEARCH_CHANGE: 'RIGS_SEARCH_CHANGE',
  RIGS_SYNC_LOADING: 'RIGS_SYNC_LOADING',
  RIGS_SYNC_IDLE: 'RIGS_SYNC_IDLE',
  RIGS_SYNC_ERROR: 'RIGS_SYNC_ERROR',

  ASSETTYPE_LIST_LOADING: 'ASSETTYPE_LIST_LOADING',
  ASSETTYPE_LIST_ERROR: 'ASSETTYPE_LIST_ERROR',
  ASSETTYPE_LIST_SUCCESS: 'ASSETTYPE_LIST_SUCCESS',
  ASSETTYPE_RESET: 'ASSETTYPE_RESET',
  ASSETTYPE_FILTER: 'ASSETTYPE_FILTER',
  ASSETTYPE_SEARCH_CHANGE: 'ASSETTYPE_SEARCH_CHANGE',

  ENVERUS_WELLS_LIST_LOADING: 'ENVERUS_WELLS_LIST_LOADING',
  ENVERUS_WELLS_LIST_ERROR: 'ENVERUS_WELLS_LIST_ERROR',
  ENVERUS_WELLS_LIST_SUCCESS: 'ENVERUS_WELLS_LIST_SUCCESS',
  ENVERUS_WELLS_RESET: 'ENVERUS_WELLS_RESET',
  ENVERUS_WELLS_FILTER: 'ENVERUS_WELLS_FILTER',
  ENVERUS_WELLS_MARKER_FILTER: 'ENVERUS_WELLS_MARKER_FILTER',
  ENVERUS_WELLS_SEARCH_CHANGE: 'ENVERUS_WELLS_SEARCH_CHANGE',
  ENVERUS_WELLS_SYNC_LOADING: 'ENVERUS_WELLS_SYNC_LOADING',
  ENVERUS_WELLS_SYNC_IDLE: 'ENVERUS_WELLS_SYNC_IDLE',
  ENVERUS_WELLS_SYNC_ERROR: 'ENVERUS_WELLS_SYNC_ERROR',
  ENVERUS_WELL_DETAILS_LOADING: 'ENVERUS_WELL_DETAILS_LOADING',
  ENVERUS_WELL_DETAILS_SUCCESS: 'ENVERUS_WELL_DETAILS_SUCCESS',
  ENVERUS_WELL_DETAILS_ERROR: 'ENVERUS_WELL_DETAILS_ERROR',
  ENVERUS_WELLS_SET_CURRENT_PAGE: 'ENVERUS_WELLS_SET_CURRENT_PAGE',

  CHECKINS_LIST_LOADING: 'CHECKINS_LIST_LOADING',
  CHECKINS_LIST_ERROR: 'CHECKINS_LIST_ERROR',
  CHECKINS_LIST_SUCCESS: 'CHECKINS_LIST_SUCCESS',
  CHECKINS_RESET: 'CHECKINS_RESET',
  CHECKINS_FILTER: 'CHECKINS_FILTER',
  CHECKINS_DIVISION_FILTER: 'CHECKINS_DIVISION_FILTER',
  CHECKINS_MARKER_FILTER: 'CHECKINS_MARKER_FILTER',
  CHECKINS_SEARCH_CHANGE: 'CHECKINS_SEARCH_CHANGE',
  CHECKINS_SYNC_LOADING: 'CHECKINS_SYNC_LOADING',
  CHECKINS_SYNC_IDLE: 'CHECKINS_SYNC_IDLE',
  CHECKINS_SYNC_ERROR: 'CHECKINS_SYNC_ERROR',
  CHECKINS_DETAILS_LOADING: 'CHECKINS_DETAILS_LOADING',
  CHECKINS_DETAILS_SUCCESS: 'CHECKINS_DETAILS_SUCCESS',
  CHECKINS_DETAILS_ERROR: 'CHECKINS_DETAILS_ERROR',
  CHECKINS_SET_CURRENT_PAGE: 'CHECKINS_SET_CURRENT_PAGE',
  CHECKINS_SET_FILTER: 'CHECKINS_SET_FILTER',
  CHECKINS_SET_SORT: 'CHECKINS_SET_SORT',
  CHECKINS_SEARCH_CONTROL: 'CHECKINS_SEARCH_CONTROL',
  CHECK_INS_EMAIL_KPIS_LOADING: 'CHECK_INS_EMAIL_KPIS_LOADING',
  CHECK_INS_EMAIL_KPIS_SUCCESS: 'CHECK_INS_EMAIL_KPIS_SUCCESS',
  CHECK_INS_EMAIL_KPIS_ERROR: 'CHECK_INS_EMAIL_KPIS_ERROR',
  CHECK_INS_DIVISION_KPIS_LOADING: 'CHECK_INS_DIVISION_KPIS_LOADING',
  CHECK_INS_DIVISION_KPIS_SUCCESS: 'CHECK_INS_DIVISION_KPIS_SUCCESS',
  CHECK_INS_DIVISION_KPIS_ERROR: 'CHECK_INS_DIVISION_KPIS_ERROR',
  USERS_PROFILE_PICTURE_UPLOAD_LOADING: 'USERS_PROFILE_PICTURE_LOADING',
  USERS_PROFILE_PICTURE_UPLOAD_ERROR: 'USERS_PROFILE_PICTURE_ERROR',
  USERS_PROFILE_PICTURE_UPLOAD_SUCCESS: 'USERS_PROFILE_PICTURE_SUCCESS',
  USERS_PROFILE_PICTURE_UPLOAD_ERROR_NOTIFIED: 'USERS_PROFILE_PICTURE_ERROR_NOTIFIED',
  USERS_PROFILE_PICTURE_SET_POD: 'USERS_PROFILE_PICTURE_SET_POD',

  HYDRAULICS_LIST_LOADING: 'HYDRAULICS_LIST_LOADING',
  HYDRAULICS_LOADING_FALSE: 'HYDRAULICS_LOADING_FALSE',
  HYDRAULICS_LIST_ERROR: 'HYDRAULICS_LIST_ERROR',
  HYDRAULICS_LIST_SUCCESS: 'HYDRAULICS_LIST_SUCCESS',
  HYDRAULICS_LIST_ERROR_NOTIFIED: 'HYDRAULICS_LIST_ERROR_NOTIFIED',
  HYDRAULICS_RESET: 'HYDRAULICS_RESET',
  HYDRAULICS_DETAILS_LIST_LOADING: 'HYDRAULICS_DETAILS_LIST_LOADING',
  HYDRAULICS_DETAILS_LIST_ERROR: 'HYDRAULICS_DETAILS_LIST_ERROR',
  HYDRAULICS_DETAILS_LIST_SUCCESS: 'HYDRAULICS_DETAILS_LIST_SUCCESS',
  HYDRAULICS_SET_ID: 'HYDRAULICS_SET_ID',
  HYDRAULICS_DETAILS_LIST_SET_FALSE: 'HYDRAULICS_DETAILS_LIST_SET_FALSE',
  HYDRAULICS_DRILL_DETAILS_LOADING: 'HYDRAULICS_DRILL_DETAILS_LOADING',
  HYDRAULICS_DRILL_DETAILS_ERROR: 'HYDRAULICS_DRILL_DETAILS_ERROR',
  HYDRAULICS_DRILL_DETAILS_SUCCESS: 'HYDRAULICS_DRILL_DETAILS_SUCCESS',
  HYDRAULICS_DRILL_DETAILS_RESET: 'HYDRAULICS_DRILL_DETAILS_RESET',
  HYDRAULICS_MUD_PUMPS_LIST_LOADING: 'HYDRAULICS_MUD_PUMPS_LIST_LOADING',
  HYDRAULICS_MUD_PUMPS_LIST_SUCCESS: 'HYDRAULICS_MUD_PUMPS_LIST_SUCCESS',
  HYDRAULICS_MUD_PUMPS_LIST_ERROR: 'HYDRAULICS_MUD_PUMPS_LIST_ERROR',
  HYDRAULICS_MUD_DISPLACEMENT_LIST_LOADING: 'HYDRAULICS_MUD_DISPLACEMENT_LIST_LOADING',
  HYDRAULICS_MUD_DISPLACEMENT_LIST_SUCCESS: 'HYDRAULICS_MUD_DISPLACEMENT_LIST_SUCCESS',
  HYDRAULICS_MUD_DISPLACEMENT_LIST_ERROR: 'HYDRAULICS_MUD_DISPLACEMENT_LIST_ERROR',
  HYDRAULICS_MUD_DISPLACEMENT_RUN_LOADING: 'HYDRAULICS_MUD_DISPLACEMENT_RUN_LOADING',
  HYDRAULICS_MUD_DISPLACEMENT_RUN_SUCCESS: 'HYDRAULICS_MUD_DISPLACEMENT_RUN_SUCCESS',
  HYDRAULICS_LANDING_FEATURED_WELL_RUN_SUCCESS: 'HYDRAULICS_LANDING_FEATURED_WELL_RUN_SUCCESS',
  HYDRAULICS_LANDING_FEATURED_WELL_RUN_LOADING: 'HYDRAULICS_LANDING_FEATURED_WELL_RUN_LOADING',
  HYDRAULICS_LANDING_FEATURED_WELL_RUN_ERROR: 'HYDRAULICS_LANDING_FEATURED_WELL_RUN_ERROR',
  HYDRAULICS_LANDING_FEATURED_RUN_DETAILS: 'HYDRAULICS_LANDING_FEATURED_RUN_DETAILS',
  HYDRAULICS_LANDING_FEATURED_RUN_DETAILS_EDIT: 'HYDRAULICS_LANDING_FEATURED_RUN_DETAILS_EDIT',
  HYDRAULICS_LANDING_SET_FEATURED_WELL_RUN_TYPE: 'HYDRAULICS_LANDING_SET_FEATURED_WELL_RUN_TYPE',
  HYDRAULICS_LANDING_SET_FEATURED_WELL_RUN_TYPE_DATA: 'HYDRAULICS_LANDING_SET_FEATURED_WELL_RUN_TYPE_DATA',
  HYDRAULICS_LANDING_RUN_LOADING: 'HYDRAULICS_LANDING_RUN_LOADING',
  HYDRAULICS_LANDING_RUN_INPUTS_CHANGED: 'HYDRAULICS_LANDING_RUN_INPUTS_CHANGED',

  HYDRAULICS_ROLLOVER_LIST_LOADING: 'HYDRAULICS_ROLLOVER_LIST_LOADING',
  HYDRAULICS_ROLLOVER_LIST_SUCCESS: 'HYDRAULICS_ROLLOVER_LIST_SUCCESS',
  HYDRAULICS_ROLLOVER_LIST_ERROR: 'HYDRAULICS_ROLLOVER_LIST_ERROR',
  HYDRAULICS_ROLLOVER_RUN_LOADING: 'HYDRAULICS_ROLLOVER_RUN_LOADING',
  HYDRAULICS_ROLLOVER_RUN_SUCCESS: 'HYDRAULICS_ROLLOVER_RUN_SUCCESS',
  HYDRAULICS_ROLLOVER_SET_FALSE: 'HYDRAULICS_ROLLOVER_SET_FALSE',
  HYDRAULICS_ROLLOVER_LIST_ERROR_NOTIFIED: 'HYDRAULICS_ROLLOVER_LIST_ERROR_NOTIFIED',
  HYDRAULICS_ROLLOVER_RESET: 'HYDRAULICS_ROLLOVER_RESET',

  CUTTINGS_PROPERTIES_LIST_LOADING: 'CUTTINGS_PROPERTIES_LIST_LOADING',
  CUTTINGS_PROPERTIES_LIST_ERROR: 'CUTTINGS_PROPERTIES_LIST_ERROR',
  CUTTINGS_PROPERTIES_LIST_SUCCESS: 'CUTTINGS_PROPERTIES_LIST_SUCCESS',
  CUTTINGS_PROPERTIES_LIST_ERROR_NOTIFIED: 'CUTTINGS_PROPERTIES_LIST_ERROR_NOTIFIED',
  CUTTINGS_PROPERTIES_RESET: 'CUTTINGS_PROPERTIES_RESET',

  CHECKINS_DRILL_LIST_LOADING: 'CHECKINS_DRILL_LIST_LOADING',
  CHECKINS_DRILL_LIST_SUCCESS: 'CHECKINS_DRILL_LIST_SUCCESS',
  CHECKINS_DRILL_LIST_ERROR: 'CHECKINS_DRILL_LIST_ERROR',
  CHECKINS_DRILL_SET_CURRENT_PAGE: 'CHECKINS_DRILL_SET_CURRENT_PAGE',
  CHECKINS_DRILL_SEARCH_CONTROL: 'CHECKINS_DRILL_SEARCH_CONTROL',
  CHECKINS_DRILL_SET_FILTER: 'CHECKINS_DRILL_SET_FILTER',
  CHECKINS_DRILL_SET_SORT: 'CHECKINS_DRILL_SET_SORT',

  CHECKINS_RIGS_LIST_LOADING: 'CHECKINS_RIGS_LIST_LOADING',
  CHECKINS_RIGS_LIST_SUCCESS: 'CHECKINS_RIGS_LIST_SUCCESS',
  CHECKINS_RIGS_LIST_ERROR: 'CHECKINS_RIGS_LIST_ERROR',

  CHECKINS_PAY_PICTURES_LIST_LOADING: 'CHECKINS_PAY_PICTURES_LIST_LOADING',
  CHECKINS_PAY_PICTURES_LIST_SUCCESS: 'CHECKINS_PAY_PICTURES_LIST_SUCCESS',
  CHECKINS_PAY_PICTURES_LIST_ERROR: 'CHECKINS_PAY_PICTURES_LIST_ERROR',

  INVENTORY_CUSTOMERS_LIST_LOADING: 'INVENTORY_CUSTOMERS_LIST_LOADING',
  INVENTORY_CUSTOMERS_LIST_SUCCESS: 'INVENTORY_CUSTOMERS_LIST_SUCCESS',
  INVENTORY_CUSTOMERS_LIST_ERROR: 'INVENTORY_CUSTOMERS_LIST_ERROR',

  USER_ORDERS_LIST_LOADING: 'USER_ORDERS_LIST_LOADING',
  USER_ORDERS_LIST_SUCCESS: 'USER_ORDERS_LIST_SUCCESS',
  USER_ORDERS_LIST_ERROR: 'USER_ORDERS_LIST_ERROR',
  USER_QUOTES_LIST_LOADING: 'USER_QUOTES_LIST_LOADING',
  USER_QUOTES_LIST_SUCCESS: 'USER_QUOTES_LIST_SUCCESS',
  USER_QUOTES_LIST_ERROR: 'USER_QUOTES_LIST_ERROR',

  DBW_VS_TARGET_LIST_LOADING: 'DBW_VS_TARGET_LIST_LOADING',
  DBW_VS_TARGET_LIST_SUCCESS: 'DBW_VS_TARGET_LIST_SUCCESS',
  DBW_VS_TARGET_LIST_ERROR: 'DBW_VS_TARGET_LIST_ERROR',
  DBW_VS_TARGET_FETCH_DETAILS_SUCCESS: 'DBW_VS_TARGET_FETCH_DETAILS_SUCCESS',
  DBW_VS_TARGET_FETCH_DETAILS_LOADING: 'DBW_VS_TARGET_FETCH_DETAILS_LOADING',
  DBW_VS_TARGET_FETCH_DETAILS_ERROR: 'DBW_VS_TARGET_FETCH_DETAILS_ERROR',
  DBW_VS_TARGET_SET_CURRENT_PAGE: 'DBW_VS_TARGET_SET_CURRENT_PAGE',
  DBW_VS_TARGET_SEARCH_CHANGE: 'DBW_VS_TARGET_SEARCH_CHANGE',
  DBW_VS_TARGET_FILTER: 'DBW_VS_TARGET_FILTER',
  DBW_VS_TARGET_SET_DATE: 'DBW_VS_TARGET_SET_DATE',
  DBW_VS_TARGET_MARKER_DATA: 'DBW_VS_TARGET_MARKER_DATA',
  DBW_VS_TARGET_DIVISION_DATA: 'DBW_VS_TARGET_DIVISION_DATA',
  DBW_VS_TARGET_DIVISION_RESET: 'DBW_VS_TARGET_DIVISION_RESET',
  DBW_SYNC_LOADING: 'DBW_SYNC_LOADING',

  SSL_GENERATE_IDLE: 'SSL_GENERATE_IDLE',
  SSL_GENERATE_LOADING: 'SSL_GENERATE_LOADING',
  SSL_GENERATE_ERROR: 'SSL_GENERATE_ERROR',

  MPDCUSTOMERS_LIST_LOADING: 'MPDCUSTOMERS_LIST_LOADING',
  MPDCUSTOMERS_LIST_SUCCESS: 'MPDCUSTOMERS_LIST_SUCCESS',
  MPDCUSTOMERS_LIST_ERROR: 'MPDCUSTOMERS_LIST_ERROR',

  HYDRAULICS_DOWNLOAD_MODEL_IDLE: 'HYDRAULICS_DOWNLOAD_MODEL_IDLE',
  HYDRAULICS_DOWNLOAD_MODEL_LOADING: 'HYDRAULICS_DOWNLOAD_MODEL_LOADING',
  HYDRAULICS_DOWNLOAD_MODEL_ERROR: 'HYDRAULICS_DOWNLOAD_MODEL_ERROR',

  STRIPPING_LIST_LOADING: 'STRIPPING_LIST_LOADING',
  STRIPPING_LIST_ERROR: 'STRIPPING_LIST_ERROR',
  STRIPPING_LIST_SUCCESS: 'STRIPPING_LIST_SUCCESS',
  STRIPPING_LIST_ERROR_NOTIFIED: 'STRIPPING_LIST_ERROR_NOTIFIED',
  STRIPPING_RESET: 'STRIPPING_RESET',
  STRIPPING_SET_FALSE: 'STRIPPING_SET_FALSE',

  HYDRAULICS_STRIPPING_RESULT_LIST_LOADING: 'HYDRAULICS_STRIPPING_RESULT_LIST_LOADING',
  HYDRAULICS_STRIPPING_RESULT_LIST_SUCCESS: 'HYDRAULICS_STRIPPING_RESULT_LIST_SUCCESS',
  HYDRAULICS_STRIPPING_RESULT_LIST_ERROR: 'HYDRAULICS_STRIPPING_RESULT_LIST_ERROR',

  HYDRAULICS_RUN_RESULT_LIST_LOADING: 'HYDRAULICS_RUN_RESULT_LIST_LOADING',
  HYDRAULICS_RUN_RESULT_LIST_SUCCESS: 'HYDRAULICS_RUN_RESULT_LIST_SUCCESS',
  HYDRAULICS_RUN_RESULT_LIST_ERROR: 'HYDRAULICS_RUN_RESULT_LIST_ERROR',
  HYDRAULICS_RUN_RESULT_LIST_RESET: 'HYDRAULICS_RUN_RESULT_LIST_RESET',

  DOWNLOAD_STRIPPING_PDF_IDLE: 'DOWNLOAD_STRIPPING_PDF_IDLE',
  DOWNLOAD_STRIPPING_PDF_LOADING: 'DOWNLOAD_STRIPPING_PDF_LOADING',
  DOWNLOAD_STRIPPING_PDF_ERROR: 'DOWNLOAD_STRIPPING_PDF_ERROR',
  HYDRAULICS_PARAMETER_ANALYSIS_LIST_LOADING: 'HYDRAULICS_PARAMETER_ANALYSIS_LIST_LOADING',
  HYDRAULICS_PARAMETER_ANALYSIS_LIST_ERROR: 'HYDRAULICS_PARAMETER_ANALYSIS_LIST_ERROR',
  HYDRAULICS_PARAMETER_ANALYSIS_LIST_SUCCESS: 'HYDRAULICS_PARAMETER_ANALYSIS_LIST_SUCCESS',
  HYDRAULICS_PARAMETER_ANALYSIS_LIST_ERROR_NOTIFIED: 'HYDRAULICS_PARAMETER_ANALYSIS_LIST_ERROR_NOTIFIED',
  HYDRAULICS_PARAMETER_ANALYSIS_RESET: 'HYDRAULICS_PARAMETER_ANALYSIS_RESET',
  HYDRAULICS_PARAMETER_ANALYSIS_SET_FALSE: 'HYDRAULICS_PARAMETER_ANALYSIS_SET_FALSE',

  HYDRAULICS_PARAMETER_ANALYSIS_DATA_LIST_LOADING: 'HYDRAULICS_PARAMETER_ANALYSIS_DATA_LIST_LOADING',
  HYDRAULICS_PARAMETER_ANALYSIS_DATA_LIST_ERROR: 'HYDRAULICS_PARAMETER_ANALYSIS_DATA_LIST_ERROR',
  HYDRAULICS_PARAMETER_ANALYSIS_DATA_LIST_SUCCESS: 'HYDRAULICS_PARAMETER_ANALYSIS_DATA_LIST_SUCCESS',

  DOWNLOAD_ROLLOVER_PDF_IDLE: 'DOWNLOAD_ROLLOVER_PDF_IDLE',
  DOWNLOAD_ROLLOVER_PDF_LOADING: 'DOWNLOAD_ROLLOVER_PDF_LOADING',
  DOWNLOAD_ROLLOVER_PDF_ERROR: 'DOWNLOAD_ROLLOVER_PDF_ERROR',
  DOWNLOAD_RAMP_SCHEDULE_PDF_IDLE: 'DOWNLOAD_RAMP_SCHEDULE_PDF_IDLE',
  DOWNLOAD_RAMP_SCHEDULE_PDF_LOADING: 'DOWNLOAD_RAMP_SCHEDULE_PDF_LOADING',
  DOWNLOAD_RAMP_SCHEDULE_PDF_ERROR: 'DOWNLOAD_RAMP_SCHEDULE_PDF_ERROR',
  DOWNLOAD_ECD_ESD_PDF_IDLE: 'DOWNLOAD_ECD_ESD_PDF_IDLE',
  DOWNLOAD_ECD_ESD_PDF_LOADING: 'DOWNLOAD_ECD_ESD_PDF_LOADING',
  DOWNLOAD_ECD_ESD_PDF_ERROR: 'DOWNLOAD_ECD_ESD_PDF_ERROR',
  DOWNLOAD_WELLS_RUN_PDF_IDLE: 'DOWNLOAD_WELLS_RUN_PDF_IDLE',
  DOWNLOAD_WELLS_RUN_PDF_LOADING: 'DOWNLOAD_WELLS_RUN_PDF_LOADING',
  DOWNLOAD_WELLS_RUN_PDF_ERROR: 'DOWNLOAD_WELLS_RUN_PDF_ERROR',
  WELLS_DRILL_FLUID_PROPERTY_LIST_LOADING: 'WELLS_DRILL_FLUID_PROPERTY_LIST_LOADING',
  WELLS_DRILL_FLUID_PROPERTY_LIST_ERROR: 'WELLS_DRILL_FLUID_PROPERTY_LIST_ERROR',
  WELLS_DRILL_FLUID_PROPERTY_LIST_SUCCESS: 'WELLS_DRILL_FLUID_PROPERTY_LIST_SUCCESS',
  WELLS_DRILL_FLUID_PROPERTY_RESETLIST: 'WELLS_DRILL_FLUID_PROPERTY_RESETLIST',

  DOWNLOAD_PARAMETRIC_PDF_IDLE: 'DOWNLOAD_PARAMETRIC_PDF_IDLE',
  DOWNLOAD_PARAMETRIC_PDF_LOADING: 'DOWNLOAD_PARAMETRIC_PDF_LOADING',
  DOWNLOAD_PARAMETRIC_PDF_ERROR: 'DOWNLOAD_PARAMETRIC_PDF_ERROR',

  DOWNLOAD_DATA_REPORT_IDLE: 'DOWNLOAD_DATA_REPORT_IDLE',
  DOWNLOAD_DATA_REPORT_LOADING: 'DOWNLOAD_DATA_REPORT_LOADING',
  DOWNLOAD_DATA_REPORT_ERROR: 'DOWNLOAD_DATA_REPORT_ERROR',

  FIREBASE_PAY_COLLECTION_LIST_LOADING: 'FIREBASE_PAY_COLLECTION_LIST_LOADING',
  FIREBASE_PAY_COLLECTION_LIST_ERROR: 'FIREBASE_PAY_COLLECTION_LIST_ERROR',
  FIREBASE_PAY_COLLECTION_LIST_SUCCESS: 'FIREBASE_PAY_COLLECTION_LIST_SUCCESS',
  FIREBASE_PAY_COLLECTION_DATA_LOADING: 'FIREBASE_PAY_COLLECTION_DATA_LOADING',
  FIREBASE_PAY_COLLECTION_DATA_ERROR: 'FIREBASE_PAY_COLLECTION_DATA_ERROR',
  FIREBASE_PAY_COLLECTION_DATA_SUCCESS: 'FIREBASE_PAY_COLLECTION_DATA_SUCCESS',
  FIREBASE_PAY_COLLECTION_DATA_ERROR_NOTIFIED: 'FIREBASE_PAY_COLLECTION_DATA_ERROR_NOTIFIED',
  FIREBASE_PAY_COLLECTION_DATA_RESET: 'FIREBASE_PAY_COLLECTION_DATA_RESET',
  FIREBASE_PAY_COLLECTION_DATA_SEARCH: 'FIREBASE_PAY_COLLECTION_DATA_SEARCH',
  FIREBASE_PAY_COLLECTION_DATA_SEARCH_RESET: 'FIREBASE_PAY_COLLECTION_DATA_SEARCH_RESET',

  FIREBASE_DRILL_COLLECTION_LIST_LOADING: 'FIREBASE_DRILL_COLLECTION_LIST_LOADING',
  FIREBASE_DRILL_COLLECTION_LIST_ERROR: 'FIREBASE_DRILL_COLLECTION_LIST_ERROR',
  FIREBASE_DRILL_COLLECTION_LIST_SUCCESS: 'FIREBASE_DRILL_COLLECTION_LIST_SUCCESS',
  FIREBASE_DRILL_COLLECTION_DATA_LOADING: 'FIREBASE_DRILL_COLLECTION_DATA_LOADING',
  FIREBASE_DRILL_COLLECTION_DATA_ERROR: 'FIREBASE_DRILL_COLLECTION_DATA_ERROR',
  FIREBASE_DRILL_COLLECTION_DATA_SUCCESS: 'FIREBASE_DRILL_COLLECTION_DATA_SUCCESS',
  FIREBASE_DRILL_COLLECTION_DATA_ERROR_NOTIFIED: 'FIREBASE_DRILL_COLLECTION_DATA_ERROR_NOTIFIED',
  FIREBASE_DRILL_COLLECTION_DATA_RESET: 'FIREBASE_DRILL_COLLECTION_DATA_RESET',
  FIREBASE_DRILL_COLLECTION_DATA_SEARCH: 'FIREBASE_DRILL_COLLECTION_DATA_SEARCH',
  FIREBASE_DRILL_COLLECTION_DATA_SEARCH_RESET: 'FIREBASE_DRILL_COLLECTION_DATA_SEARCH_RESET',

  OBSERVATION_LIST_LOADING: 'OBSERVATION_LIST_LOADING',
  OBSERVATION_LIST_ERROR: 'OBSERVATION_LIST_ERROR',
  OBSERVATION_LIST_SUCCESS: 'OBSERVATION_LIST_SUCCESS',
  OBSERVATION_LIST_RESET: 'OBSERVATION_LIST_RESET',

  WELLS_PWD_LIST_LOADING: 'WELLS_PWD_LIST_LOADING',
  WELLS_PWD_LIST_ERROR: 'WELLS_PWD_LIST_ERROR',
  WELLS_PWD_LIST_SUCCESS: 'WELLS_PWD_LIST_SUCCESS',
  WELLS_PWD_LIST_ERROR_NOTIFIED: 'WELLS_PWD_LIST_ERROR_NOTIFIED',
  WELLS_PWD_RESET: 'WELLS_PWD_RESET',

  SET_HYDRAULICS_ECD_CHARTS_XAXIS: 'SET_HYDRAULICS_ECD_CHARTS_XAXIS',
  SET_HYDRAULICS_ECD_CHARTS_YAXIS: 'SET_HYDRAULICS_ECD_CHARTS_YAXIS',

  HYDRAULICS_DISPLACEMENT_LIST_LOADING: 'HYDRAULICS_DISPLACEMENT_LIST_LOADING',
  HYDRAULICS_DISPLACEMENT_LIST_ERROR: 'HYDRAULICS_DISPLACEMENT_LIST_ERROR',
  HYDRAULICS_DISPLACEMENT_LIST_SUCCESS: 'HYDRAULICS_DISPLACEMENT_LIST_SUCCESS',
  HYDRAULICS_DISPLACEMENT_LIST_ERROR_NOTIFIED: 'HYDRAULICS_DISPLACEMENT_LIST_ERROR_NOTIFIED',
  HYDRAULICS_DISPLACEMENT_RESET: 'HYDRAULICS_DISPLACEMENT_RESET',
  HYDRAULICS_DISPLACEMENT_SET_FALSE: 'HYDRAULICS_DISPLACEMENT_SET_FALSE',

  HYDRAULICS_DISPLACEMENT_RESULT_LIST_LOADING: 'HYDRAULICS_DISPLACEMENT_RESULT_LIST_LOADING',
  HYDRAULICS_DISPLACEMENT_RESULT_LIST_SUCCESS: 'HYDRAULICS_DISPLACEMENT_RESULT_LIST_SUCCESS',
  HYDRAULICS_DISPLACEMENT_RESULT_LIST_ERROR: 'HYDRAULICS_DISPLACEMENT_RESULT_LIST_ERROR',
  DOWNLOAD_DISPLACEMENT_PDF_IDLE: 'DOWNLOAD_DISPLACEMENT_PDF_IDLE',
  DOWNLOAD_DISPLACEMENT_PDF_LOADING: 'DOWNLOAD_DISPLACEMENT_PDF_LOADING',
  DOWNLOAD_DISPLACEMENT_PDF_ERROR: 'DOWNLOAD_DISPLACEMENT_PDF_ERROR',

  WELLBORE_VOLUME_LIST_LOADING: 'WELLBORE_VOLUME_LIST_LOADING',
  WELLBORE_VOLUME_LIST_ERROR: 'WELLBORE_VOLUME_LIST_ERROR',
  WELLBORE_VOLUME_LIST_SUCCESS: 'WELLBORE_VOLUME_LIST_SUCCESS',
  WELLBORE_VOLUME_RESET: 'WELLBORE_VOLUME_RESET',
  ASSETS_MAP_LIST_LOADING: 'ASSETS_MAP_LIST_LOADING',
  ASSETS_MAP_LIST_ERROR: 'ASSETS_MAP_LIST_ERROR',
  ASSETS_MAP_LIST_SUCCESS: 'ASSETS_MAP_LIST_SUCCESS',
  ASSETS_MAP_RESET: 'ASSETS_MAP_RESET',
  ASSETS_MAP_SEARCH_CHANGE: 'ASSETS_MAP_SEARCH_CHANGE',
  ASSETS_MAP_FILTER: 'ASSETS_MAP_FILTER',
  ASSETS_MAP_MARKER_FILTER: 'ASSETS_MAP_MARKER_FILTER',

  FIELD_PICTURES_DRILL_LIST_LOADING: 'FIELD_PICTURES_DRILL_LIST_LOADING',
  FIELD_PICTURES_DRILL_LIST_SUCCESS: 'FIELD_PICTURES_DRILL_LIST_SUCCESS',
  FIELD_PICTURES_DRILL_LIST_ERROR: 'FIELD_PICTURES_DRILL_LIST_ERROR',
  FIELD_PICTURES_DRILL_SEARCH_CHANGE: 'FIELD_PICTURES_DRILL_SEARCH_CHANGE',
  FIELD_PICTURES_DRILL_FILTER: 'FIELD_PICTURES_DRILL_FILTER',
  FIELD_PICTURES_DRILL_GRID_FILTER: 'FIELD_PICTURES_DRILL_GRID_FILTER',
  FIELD_PICTURES_DRILL_SET_CURRENT_PAGE: 'FIELD_PICTURES_DRILL_SET_CURRENT_PAGE',
  FIELD_PICTURES_DRILL_SET_FILTER: 'FIELD_PICTURES_DRILL_SET_FILTER',
  FIELD_PICTURES_DRILL_SET_SORT: 'FIELD_PICTURES_DRILL_SET_SORT',
  FIELD_PICTURES_DRILL_SEARCH_CONTROL: 'FIELD_PICTURES_DRILL_SEARCH_CONTROL',

  REALTIME_COLLECTIONS_LIST_LOADING: 'REALTIME_COLLECTIONS_LIST_LOADING',
  REALTIME_COLLECTIONS_LIST_ERROR: 'REALTIME_COLLECTIONS_LIST_ERROR',
  REALTIME_COLLECTIONS_LIST_SUCCESS: 'REALTIME_COLLECTIONS_LIST_SUCCESS',
  REALTIME_COLLECTIONS_LIST_CLEAR: 'REALTIME_COLLECTIONS_LIST_CLEAR',
  REALTIME_COLLECTIONS_LIST_ERROR_NOTIFIED: 'REALTIME_COLLECTIONS_LIST_ERROR_NOTIFIED',
  REALTIME_COLLECTIONS_RESET: 'REALTIME_COLLECTIONS_RESET',
  REALTIME_COLLECTIONS_SEARCH_FILTER: 'REALTIME_COLLECTIONS_SEARCH_FILTER',

  WELLBORE_MUDPROFILE_LIST_LOADING: 'WELLBORE_MUDPROFILE_LIST_LOADING',
  WELLBORE_MUDPROFILE_LIST_ERROR: 'WELLBORE_MUDPROFILE_LIST_ERROR',
  WELLBORE_MUDPROFILE_LIST_SUCCESS: 'WELLBORE_MUDPROFILE_LIST_SUCCESS',
  WELLBORE_MUDPROFILE_RESET: 'WELLBORE_MUDPROFILE_RESET',

  REALTIME_COLLECTIONS_LIST_LOADING_FINISH: 'REALTIME_COLLECTIONS_LIST_LOADING_FINISH',

  PAY_TARGETS_LIST_LOADING: 'PAY_TARGETS_LIST_LOADING',
  PAY_TARGETS_LIST_SUCCESS: 'PAY_TARGETS_LIST_SUCCESS',
  PAY_TARGETS_LIST_ERROR: 'PAY_TARGETS_LIST_ERROR',
  PAY_TARGETS_SEARCH_CHANGE: 'PAY_TARGETS_SEARCH_CHANGE',

  PAY_TARGETS_QUESTIONS_LIST_LOADING: 'PAY_TARGETS_QUESTIONS_LIST_LOADING',
  PAY_TARGETS_QUESTIONS_LIST_SUCCESS: 'PAY_TARGETS_QUESTIONS_LIST_SUCCESS',
  PAY_TARGETS_QUESTIONS_LIST_ERROR: 'PAY_TARGETS_QUESTIONS_LIST_ERROR',
  PAY_TARGETS_QUESTIONS_RESET: 'PAY_TARGETS_QUESTIONS_RESET',

  TARGET_ANSWERS_LIST_LOADING: 'TARGET_ANSWERS_LIST_LOADING',
  TARGET_ANSWERS_LIST_SUCCESS: 'TARGET_ANSWERS_LIST_SUCCESS',
  TARGET_ANSWERS_LIST_ERROR: 'TARGET_ANSWERS_LIST_ERROR',
  TARGET_ANSWERS_RESET: 'TARGET_ANSWERS_RESET',
  TARGET_ANSWERS_SEARCH_CONTROL: 'TARGET_ANSWERS_SEARCH_CONTROL',

  PERMISSIONS_LIST_LOADING: 'PERMISSIONS_LIST_LOADING',
  PERMISSIONS_LIST_SUCCESS: 'PERMISSIONS_LIST_SUCCESS',
  PERMISSIONS_LIST_ERROR: 'PERMISSIONS_LIST_ERROR',
  PERMISSIONS_LIST_RESET: 'PERMISSIONS_LIST_RESET',
  PERMISSIONS_WELLS_USERS_SUCESS: 'PERMISSIONS_WELLS_USERS_SUCESS',
  PERMISSIONS_WELLS_USERS_LOADING: 'PERMISSIONS_WELLS_USERS_LOADING',
  PERMISSIONS_WELLS_USERS_ERROR: 'PERMISSIONS_WELLS_USERS_ERROR',
};
